module.exports = __webpack_public_path__ + "img/example_logo_blackwhite.6197cdaa.png";